var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTelega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.54 12.6701L26.25 26.3801C26.2365 26.4636 26.2044 26.543 26.1559 26.6122C26.1074 26.6815 26.0438 26.7389 25.97 26.7801C25.895 26.8243 25.8105 26.8501 25.7236 26.8553C25.6367 26.8606 25.5497 26.8451 25.47 26.8101L21.43 25.1601L19.27 27.7901C19.17 27.9301 19.02 28.0001 18.83 28.0001C18.737 28.0007 18.6454 27.9782 18.5634 27.9345C18.4813 27.8909 18.4114 27.8275 18.36 27.7501C18.2947 27.6562 18.2599 27.5445 18.26 27.4301V24.3001L25.98 14.8501L16.43 23.1101L12.91 21.6701C12.8045 21.636 12.7127 21.5691 12.648 21.4792C12.5832 21.3892 12.5489 21.2809 12.55 21.1701C12.5398 21.0654 12.561 20.9601 12.6108 20.8675C12.6607 20.7749 12.737 20.6992 12.83 20.6501L27.7 12.0801C27.7912 12.025 27.8964 11.9975 28.0029 12.001C28.1095 12.0046 28.2127 12.039 28.3 12.1001C28.5 12.2401 28.58 12.4301 28.55 12.6701H28.54Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTelega);
export default __webpack_public_path__ + "static/media/footerTelega.74ef9b6177733da7d7a422eff1913b5f.svg";
export { ForwardRef as ReactComponent };